const SuggestionBehavior = Object.freeze({
    PRESELECT: 'preselect',
    RECOMMEND: 'recommend',
})

const clone = value => JSON.parse(JSON.stringify(value || {}))

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value)

const setPath = (target, path, value) => {
    const segments = path.split('.').filter(Boolean)
    let cursor = target

    segments.slice(0, -1).forEach(segment => {
        if (!isObject(cursor[segment])) {
            cursor[segment] = {}
        }
        cursor = cursor[segment]
    })

    cursor[segments[segments.length - 1]] = value
}

const scopeFromExtractedProductsPolicy = Object.freeze({
    id: 'suggest-scope-from-extracted-products',
    evaluate({ item, draft }) {
        const hasReviewedPayload = item && isObject(item.reviewedPayload)
        const scope = draft && draft.classification ? draft.classification.scope : null
        const products = draft && Array.isArray(draft.products) ? draft.products : []

        if (hasReviewedPayload || (item && item.status === 'reviewed')) {
            return null
        }

        if (scope && scope !== 'unknown') {
            return null
        }

        const hasProducts = products.length > 0

        return {
            path: 'classification.scope',
            value: hasProducts ? 'product_specific' : 'global_supplier',
            reasonKey: hasProducts
                ? 'Component(ResearchReviewSuggestion):product-specific-scope-reason'
                : 'Component(ResearchReviewSuggestion):global-supplier-scope-reason',
            fallbackReason: hasProducts
                ? 'Product specific was selected because products were extracted from the document.'
                : 'Global supplier was selected because no products were extracted from the document.',
        }
    },
})

const SUGGESTION_POLICIES = Object.freeze({
    [scopeFromExtractedProductsPolicy.id]: scopeFromExtractedProductsPolicy,
})

const applyReviewSuggestions = (configurations, input) => {
    const draft = clone(input.draft)
    const suggestions = []
    const policies = Array.isArray(configurations) ? configurations : []

    policies.forEach(configuration => {
        const policy = configuration && SUGGESTION_POLICIES[configuration.policy]
        if (!policy) {
            return
        }

        const behavior = configuration.behavior === SuggestionBehavior.RECOMMEND
            ? SuggestionBehavior.RECOMMEND
            : SuggestionBehavior.PRESELECT
        const result = policy.evaluate({
            ...input,
            draft,
        })

        if (!result) {
            return
        }

        const suggestion = {
            policy: policy.id,
            behavior,
            ...result,
        }

        suggestions.push(suggestion)
        if (behavior === SuggestionBehavior.PRESELECT) {
            setPath(draft, suggestion.path, suggestion.value)
        }
    })

    return { draft, suggestions }
}

export {
    SuggestionBehavior,
    applyReviewSuggestions,
}
